var _templateObject, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgCloutChase = function SvgCloutChase(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ebe5d2",
    stroke: "currentColor",
    d: "M26.19.5 39.5 13.81v21.92h-3.77v3.77H13.813L.5 26.19V4.27h3.771V.5z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M31.863 30.66a1.56 1.56 0 0 1 1.783.968l-.642.246a.875.875 0 1 0 .029.54l.664.178a1.562 1.562 0 1 1-1.834-1.933"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    fillRule: "evenodd",
    d: "M32.188 29.375a2.813 2.813 0 1 1 0 5.625 2.813 2.813 0 0 1 0-5.625m0 .619a2.193 2.193 0 1 0 0 4.387 2.193 2.193 0 0 0 0-4.387",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clout-chase_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d37047",
    fillRule: "evenodd",
    d: "M12.5 8.75h5V5h3.75v3.75H25v3.75h-3.75v5H25v3.75h-3.75V25H17.5v-3.75h-5V25H8.75v-3.75H5V17.5h3.75v-5H5V8.75h3.75V5h3.75zm0 3.75v5h5v-5z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clout-chase_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h20v20H5z"
  }))))));
};
export default SvgCloutChase;